const GOOGLE_ADS_CONVERSION_ID = "AW-11207669379";
const GOOGLE_ADS_LEAD_LABEL = "Jk6HCK3C4dccElPtneAp";

export const trackLeadConversion = () => {
    if (typeof window === "undefined") {
        return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: "submit_lead_form" });

    if (typeof window.gtag === "function") {
        window.gtag("event", "conversion", {
            send_to: `${GOOGLE_ADS_CONVERSION_ID}/${GOOGLE_ADS_LEAD_LABEL}`,
        });
    }
};
